export default __webpack_public_path__ + "static/media/roadmap3.e0850489.png";